<template>
    <div class="flex flex-col">
        <h2 class="about-title text-7xl lg:text-9xl text-uppercase font-vectrex !leading-tight whitespace-nowrap">
            {{ title }}
        </h2>
        <AtomSectionSeparator />
    </div>
</template>

<script>
import AtomSectionSeparator from "../../global/atoms/AtomSectionSeparator.vue";

export default {
    name: 'AtomFolderTitleOpaque',
    components: {AtomSectionSeparator},
    props: {
        title: {
            type: String,
            required: true,
        }
    }
}
</script>

<style scoped lang="scss">
.about-title {
    -webkit-mask-image: linear-gradient(0deg, transparent 35px, red 85px);
    @media (min-width: 1024px) {
        & {
            -webkit-mask-image: linear-gradient(0deg, transparent 60px, red 145px);
        }
    }
}
</style>
